import React from 'react'
import ISOSelector from './ISOSelector'
import RepSelector from './RepSelector'

interface ISORepSelectorProps {
  type: 'ISO' | 'Rep'
  value?: {
    ids?: number[]
    fee?: number
    splitCommission?: any[],
    commissionDueDate?: string
  }
  onChange: (value: any) => void
  disabled?: boolean
  advanceAmount?: number
  dealStartDate?: string
  hideCommissionDueDateField?: boolean
  disableIsoCommissionDueDateField?: boolean
  disableRepCommissionDueDateField?: boolean
}

const ISORepSelector: React.FC<ISORepSelectorProps> = ({
  type,
  value,
  onChange,
  disabled = false,
  advanceAmount = 0,
  dealStartDate,
  hideCommissionDueDateField = true,
  disableIsoCommissionDueDateField = false,
  disableRepCommissionDueDateField = false
}) => {
  if (type === 'ISO') {
    return (
      <ISOSelector
        value={value}
        onChange={onChange}
        disabled={disabled}
        advanceAmount={advanceAmount}
        dealStartDate={dealStartDate}
        hideCommissionDueDateField={hideCommissionDueDateField}
        disableCommissionDueDateField={disableIsoCommissionDueDateField}
      />
    )
  }

  return (
    <RepSelector
      value={value}
      onChange={onChange}
      disabled={disabled}
      advanceAmount={advanceAmount}
      dealStartDate={dealStartDate}
      hideCommissionDueDateField={hideCommissionDueDateField}
      disableCommissionDueDateField={disableRepCommissionDueDateField}
    />
  )
}

export default ISORepSelector
